export enum CultureEnum {
  nlNL = 'nl-NL',
  enGB = 'en-GB',
  frFR = 'fr-FR',
  nlBL = 'nl-BE',
}

export type CultureEnumType = keyof typeof CultureEnum;
